const BASE_URL = '';
const PRINT_URL = ''

export {
    BASE_URL,
    PRINT_URL,
};
